import React, { useContext, useEffect, useState } from 'react';
import { Container, Grid } from '@material-ui/core';
import Regulation from './Regulation';
import InternalHeader from '../components/InternalHeader';
import { URLContext } from '../../contexts/URLContext';
import ErrorScreen from '../components/ErrorScreen';

const Regulations = () => {
  const {globalUserID, globalCampaignID} = useContext(URLContext);
  const [ isParamsOK, setIsParamsOK ] = useState(true);

  useEffect(() => {
    setIsParamsOK( !(globalCampaignID == null) )
  }, [globalUserID, globalCampaignID]);
  
  return (
    <Container style={{padding: 0, backgroundColor: "#FAFAFA", maxWidth: 550}}>
      {isParamsOK ? (
        <Grid container>
          <Grid item xs={12}>
            <InternalHeader to="faq" />
            <Regulation />
          </Grid>
        </Grid>
      ):(
        <ErrorScreen>
          {`Ooops...<br/>
          Não foi possível encontrar o Regulamento.<br/>
          Verifique se a URL está correta.`}
        </ErrorScreen>
      )}
    </Container>
  );
};

export default Regulations;